<button 
  class="points__add-new-point-card"
  (click)="handleAddNewPointClick()"
>
  <ci-icon 
    type="svg" 
    name="btn-add" 
    scale="3x"
  ></ci-icon>
</button>